import { Injectable, isDevMode } from '@angular/core';
import { LabelService } from './label.service';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';


@Injectable({
    providedIn: 'root'
})
export class DeviceAgentSerivce {

    constructor(private labelService: LabelService, private messageService: MessageService, private translateService: TranslateService, private sanitizer: DomSanitizer) {

    }

    async PrintLabelFromIOS(shipmentIds: any, type: any, queryParams: any) {
        // autoReady        
        try {
            if (type === "label" || isDevMode()) {
                const base64Pdf = await this.labelService.getMultipleLabelsV2(shipmentIds);                
                const blob = await this.base64ToBlobv2(base64Pdf)                
                this.BuildPDFObject(blob)
            } else {
                const downloadUrl = `${environment.apiUrl}/shipments/print?${queryParams.toString()}`;
                const response = await fetch(downloadUrl, { method: 'GET' });
                if (!response.ok)
                    throw new Error('Failed to fetch PDF');
                const blob = await response.blob();
                this.BuildPDFObject(blob)
            }
        } catch (error) {
            console.error('iOS PDF download failed:', error);
            this.messageService.add({
                severity: 'error',
                detail: "failed to print on ios with type: " + type + " and with ShipmentId: " + shipmentIds,
                summary: this.translateService.instant('MESSAGES.PDFDOWNLOADERROR'),
            });
        }
    }

    private BuildPDFObject(blob: any) {        
        const blobUrl = URL.createObjectURL(blob);

        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = 'shipment.pdf';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(blobUrl);


    }


    base64ToBlob(base64: string, mime = 'application/pdf') {
        const byteCharacters = atob(base64.split(',')[1]);
        const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    }
    async base64ToBlobv2(base64: Uint8Array | Blob, mime = 'application/pdf') {
        if (typeof (base64) == typeof (Blob)) {
            let arg = (await (base64 as Blob).stream().getReader().read()).value;
            return new Blob([arg], { type: mime })
        } else {
            const byteArray = new Uint8Array(base64 as Uint8Array);
            return new Blob([byteArray], { type: mime });
        }
    }
    /**
     * 
     * @param shipmentIds the shipments ids to feacth the labes for
     * @param type the type of label
     * @param queryParams no godnam ide
     */
    async PrintMutilpleLabels(shipmentIds: any, type: any, queryParams) {

    }
    
}

/**
* 
* @returns a string containing what os the user is using.
*/
export function getOS(): 'iOS' | 'Android' | 'Windows' | 'Mac' | 'Linux' | 'Unknown' {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|MacIntel|Mac|Macintosh|iPod/.test(userAgent)) {
        return 'iOS';
    } else if (/Android/.test(userAgent)) {
        return 'Android';
    } else if (/Win/.test(userAgent)) {
        return 'Windows';
    } else if (/Mac/.test(userAgent)) {
        return 'Mac';
    } else if (/Linux/.test(userAgent)) {
        return 'Linux';
    } else {
        return 'Unknown';
    }
}